import React from "react";

const Transfer = ({ show, setShow }) => {
  return (
    <>
      {show ? (
        <div className="profile-modal-overlay">
          <div className="profile-modal-container">
            <div className="close-profile">
              <button className="profile-close-button">
                <button
                  className="profile-close-button"
                  onClick={() => setShow(false)}
                >
                  <img src="/icons/cancel.svg" alt="" />
                </button>
              </button>
            </div>
            <h2 className="profile-modal-title">Transfer Wallet</h2>

            <div className="profile-form-section">
              <input
                type="text"
                placeholder="Wallet Address"
                className="profile-form-input"
              />

              <input
                type="text"
                placeholder="Amount"
                className="profile-form-input"
              />
              <button className="profile-save-button">Copy Key</button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Transfer;
